(() => {
  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      instances.forEach(instance => instance.update());
    });
  };
  const init = root => {
    if (instances.has(root)) return;
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const tabs = $$('[data-ps-review-view]');
    const panels = $$('[data-ps-review-panel]');
    const columns = $$('[data-ps-review-column]');
    const carousel = $('[data-ps-review-carousel]');
    const cards = [...carousel.querySelectorAll('[data-ps-review-card]')];
    const dialog = $('[data-ps-full-review]');
    const controller = new AbortController();
    const on = (target, event, fn, options = {}) => target.addEventListener(event, fn, {...options, signal: controller.signal});
    let view = root.dataset.defaultView;
    let paused = false;
    let returnFocus;
    const pauseVideos = except => $$('video').forEach(video => {
      if (video !== except && !video.paused) video.pause();
    });
    const updateCarousel = () => {
      const max = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      const left = carousel.scrollLeft;
      const first = cards[0]?.getBoundingClientRect();
      let index = 0;
      if (first) cards.forEach((card, i) => {
        if (card.getBoundingClientRect().left - first.left <= left + 5) index = i;
      });
      $('[data-ps-review-position]').textContent = String(index + 1);
      $('[data-ps-review-step="-1"]').disabled = left <= 2;
      $('[data-ps-review-step="1"]').disabled = left >= max - 2;
    };
    const moveCarousel = step => {
      const width = cards[0]?.getBoundingClientRect().width || carousel.clientWidth;
      const gap = parseFloat(getComputedStyle(carousel).columnGap) || 24;
      carousel.scrollBy({left: (width + gap) * step, behavior: reduced.matches ? 'instant' : 'smooth'});
    };
    const updateMotion = () => {
      if (reduced.matches) {
        columns.forEach(column => column.style.removeProperty('--ps-column-y'));
        return;
      }
      if (view !== 'wall' || paused || root.dataset.scrollMotion !== 'true' || columns.some(column => column.contains(document.activeElement))) return;
      const bounds = $('[data-ps-review-panel="wall"]').getBoundingClientRect();
      if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;
      const progress = clamp((window.innerHeight - bounds.top) / (window.innerHeight + bounds.height), 0, 1);
      const distance = parseFloat(getComputedStyle(root).getPropertyValue('--ps-review-distance')) || 80;
      columns.forEach((column, i) => column.style.setProperty('--ps-column-y', `${((progress - 0.5) * distance * (i % 2 ? -1 : 1)).toFixed(2)}px`));
    };
    const setView = (next, focus = false) => {
      view = next;
      tabs.forEach(tab => {
        const active = tab.dataset.psReviewView === next;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus({preventScroll:true});
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.psReviewPanel !== next; });
      pauseVideos();
      schedule();
    };
    on(root, 'click', async event => {
      const target = event.target.closest('button');
      if (!target) return;
      if (target.matches('[data-ps-review-view]')) setView(target.dataset.psReviewView);
      if (target.matches('[data-ps-review-motion]')) {
        paused = !paused;
        root.classList.toggle('ps-review-motion-paused', paused);
        target.setAttribute('aria-pressed', String(paused));
        target.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
        $('[data-ps-review-motion-label]').textContent = paused ? root.dataset.resumeLabel : root.dataset.pauseLabel;
        schedule();
      }
      if (target.matches('[data-ps-review-step]')) moveCarousel(Number(target.dataset.psReviewStep));
      if (target.matches('[data-ps-review-read]')) {
        const template = target.closest('[data-ps-review-card]').querySelector('[data-ps-review-full]');
        $('[data-ps-full-review-content]').replaceChildren(template.content.cloneNode(true));
        returnFocus = target;
        if (!dialog.open) dialog.showModal();
      }
      if (target.matches('[data-ps-review-close]')) dialog.close();
      if (target.matches('[data-ps-review-play]')) {
        const media = target.closest('.ps-review-media');
        const video = media.querySelector('video');
        if (!video) return;
        pauseVideos(video);
        media.querySelector('.ps-review-video-error')?.remove();
        video.controls = true;
        video.playsInline = true;
        media.classList.add('ps-is-playing');
        target.hidden = true;
        try {
          await video.play();
          if (view !== 'stories' || !root.isConnected) video.pause();
        } catch (_) {
          const message = document.createElement('p');
          message.className = 'ps-review-video-error';
          message.setAttribute('role', 'status');
          message.textContent = root.dataset.videoError;
          media.append(message);
        }
      }
    });
    on(root, 'keydown', event => {
      const tab = event.target.closest('[data-ps-review-view]');
      if (tab && ['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        setView(tabs[next].dataset.psReviewView, true);
      } else if (event.target === carousel && ['ArrowLeft','ArrowRight'].includes(event.key)) {
        event.preventDefault();
        moveCarousel(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    on(carousel, 'scroll', schedule, {passive:true});
    on(root, 'focusout', schedule);
    on(dialog, 'close', () => { returnFocus?.focus({preventScroll:true}); });
    on(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    $$('video').forEach(video => {
      on(video, 'play', () => pauseVideos(video));
      on(video, 'ended', () => {
        const media = video.closest('.ps-review-media');
        media.classList.remove('ps-is-playing');
        media.querySelector('[data-ps-review-play]').hidden = false;
        video.controls = false;
      });
    });
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    observer?.observe(root);
    instances.set(root, {
      update: () => { updateMotion(); if (view === 'stories') updateCarousel(); },
      selectBlock: id => {
        paused = true;
        const card = panels.find(panel => !panel.hidden)?.querySelector(`[data-ps-review-block="${CSS.escape(id)}"]`);
        card?.scrollIntoView({behavior:'instant', block:'center', inline:'center'});
      },
      destroy: () => { pauseVideos(); observer?.disconnect(); controller.abort(); }
    });
    setView(view);
  };
  const initAll = () => document.querySelectorAll('[data-ps-reviews]').forEach(init);
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  reduced.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, root) => {
      if (event.target.contains(root)) { instance.destroy(); instances.delete(root); }
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-ps-reviews]');
    instances.get(root)?.selectBlock(event.detail.blockId);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
